import { onActivated, onDeactivated, onMounted, onUnmounted } from 'vue';
import { useDevicesStore } from '@/stores/devices';

/**
 * Poll the online-device counts while the calling component is mounted and
 * active (keep-alive aware). Consumers are reference-counted in the store:
 * during a route transition the entering tree mounts before the leaving one
 * deactivates, so an unpaired stop would kill the polling the entering
 * component just started.
 */
export function useDevicesCountPolling(routeIds: string[] = []) {
  const devicesStore = useDevicesStore();
  const consumer = Symbol('devices-count-consumer');

  const acquire = () => devicesStore.acquireDevicesCount(consumer, routeIds);
  const release = () => devicesStore.releaseDevicesCount(consumer);

  onMounted(acquire);
  onActivated(acquire);
  onDeactivated(release);
  onUnmounted(release);
}
